<template>
  <Page :title="title">
    <!-- 导航栏 -->
    <!-- <van-nav-bar :title="title" @click-left="onClickLeft" @click-right="onClickRight" left-arrow>
      <van-icon name="ellipsis" slot="right"/>
    </van-nav-bar>-->
    <!-- 顶部筛选栏   输入框  搜索 -->
    <div class="header-titile-all">
      <div class="header_top">
        <div class="searchTitle-top-header flex">
          <div class="searchTitle-top">
            <div class="flex input-search-flex">
              <input
                type="text"
                placeholder="课程名称/城市/导师名称"
                class="search_input"
                v-model="search_input"
                oninput="if(value.length>80)value=value.slice(0,80)"
                @keyup.enter="search"
              >
              <img :src="require('@/assets/img/search.png')" class="search-img" alt @click="search">
            </div>
          </div>
          <div class="filtrate-list flex">
            <img :src="require('@/assets/img/filtrate.png')" class="filtrate-img" alt>
            <div @click="searchFilter">筛选</div>
          </div>
        </div>
        <van-row type="flex" justify="space-around" class="filtratelist">
          <van-col
            span="6"
            :title="item.name"
            v-for="(item,index) in filtrateList"
            v-bind:key="index"
          >
            <div @click="downSelectionL(index)" class="span_text span_text_flex">{{item.name}}
                             <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
            </div>
            <!-- Picker 选择器 -->
            <van-popup v-model="item.show" position="bottom" :overlay="true">
              <van-picker
                show-toolbar
                :title="item.name"
                :columns="item.pickerList"
                @cancel="onCancel($event,index)"
                @confirm="onConfirm($event,item,index)"
                value-key="name"
              />
            </van-popup>
          </van-col>
          <!-- 点击跳转日历 -->
          <van-col span="3">
            <img
              :src="require('@/assets/img/v2_pl2gj1.png')"
              draggable="false"
              class="v2_pl2gj1"
              @click="calendar"
            >
          </van-col>
        </van-row>
      </div>


     <!-- 定位 -->
    <div :class="hasAddAuth ? 'orientation-bottom' : 'orientation-bottom-1'">
      <!-- 主页 -->
      <div class="homePage" @click="home">
        <img :src="require('@/assets/img/homePage.png')" class="homePageImg" alt="">
      </div>
      <!-- 添加 -->
      <div class="add"  @click="addCurriculum" v-if="hasAddAuth">
        <img :src="require('@/assets/img/add.png')" class="addImg" alt="">
      </div>
    </div>



    </div>
         <!-- 华东区域 列表内容 -->
      <div class="listcontent">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多的数据了"
          loading-text="正在加载数据"
          error-text="加载失败请重试"
          @load="onLoad"
          :immediate-check="false"
        >
          <div
            class="information-list"
            v-for="(item,index) in list"
            v-bind:key="index"
            @click="toDetail(item,index)"
          >
           <div class="list-row">
                <div class="list-row-item">课程类型</div>
                <div class="list-row-items top-flex">{{item.type}}
                <div class="list-row concal-flex"
                    v-show="item.status==0?true:false"
                    style="color: red;font-weight: bold;"
                >
                已取消
              </div>

                </div>
           </div>
           <div class="list-row">
                <div class="list-row-item">课程名称</div>
                <div class="list-row-items">{{item.name}}</div>
           </div>
           <div class="list-row">
                <div class="list-row-item">课程导师</div>
                <div class="list-row-items">{{item.teacherName}}</div>
           </div>
           <div class="list-row">
                <div class="list-row-item">日期</div>
                <div class="list-row-items">{{item.courseTime}}</div>
           </div>
           <div class="list-row">
                <div class="list-row-item">城市</div>
                <div class="list-row-items">{{item.city}}</div>
           </div>
           <div class="list-row">
                <div class="list-row-item">学员人数</div>
                <div class="list-row-items">{{item.studentCnt}}</div>
           </div>


          </div>
        </van-list>
      </div>
            <!-- 数据加载显示 -->
      <div class="loaded"  >已加载 {{list.length}}/{{totalRow}}</div>


     <!--   重置区域    -->
                 <!-- 下拉筛选 -->
            <van-popup v-model="showDownSelection" position="bottom" :overlay="true">
                <van-picker
                    show-toolbar
                    title=""
                    :columns="downSelection"
                    @cancel="onCancelCode"
                    @confirm="onConfirmCode"
                     :value-key="'name'"
                    class="van-picker-li"
                />
            </van-popup>


  </Page>
</template>

<script>
let dictionary = {},
  findContuny;
import { Toast, Notify } from "vant";
export default {
  name: "listCurriculum",
  data() {
    return {
      search_input: null, //搜索字符串
      count2: 5,
      count1: 5,
      list: [],
      loading: false,
      finished: false,
      active: true,
      title: "课程列表",
      filtrateList: [
        {
          name: "全部日期",
          show: false,
          attribute: "dateType",
          pickerList: [],
          statue: 0
        },
        {
          name: "全部课程",
          show: false,
          attribute: "courseType",
          pickerList: [],
          statue: 0
        },
        {
          name: "导师类型",
          show: false,
          attribute: "teacherType",
          pickerList: [],
          statue: 0
        },
        {
          name: "学员类型",
          show: false,
          attribute: "studentType",
          pickerList: [],
          statue: 0
        }
      ],
      //内容
      listcontent: [],
      totalRow: 0, //	总条数
      pageNumber: 1, // 当前页
      firstPage: 0, //	非必须
      lastPage: 0, //	非必须
      totalPage: 0, //	总页数
      pageSize: 10, //	每页条数

    ///////////////////////////-   重置  -////////////////////////////////
    // 字典表查询code
    codeList:['CourseDateSearch','Classes','teacherType','StudentType'],
    dateTypeList:[],    //全部日期
    courseTypeList:[],  //全部课程
    teacherTypeList:[], //导师类型
    studentTypeList:[], //学员类型
    showDownSelection:false, //下拉框展示
    downSelection:[], //下拉框列表数据
    likeName:"",      //模糊查询
    dateType:"",     //日期类型1、最近一周 2、最近一月 3、最近三个月 4、最近半年
    courseType:"",   //课程类型
    teacherType:"",  //导师类型
    studentType:"",  //学员类型
    courseName:"",   //课程名称
    teacherId:"",    //培训导师
    startDate:"",    //课程开始日期
    endDate:"",      //课程结果日期
    country:"",      //国家
    city:"",         //城市
    startStudentCnt:"",  //学员开始人数
    endStudentCnt:"",    //学员结束人数
    currency:"",         //课程费用币种
    startPrice:"",       //单人费用开始费用
    endPrice:"",         //单人费用结束费用
    startAmount:"",      //费用合计开始
    endAmount:"",        //费用合计结束
    neededShow:"",       //是否需要提交作品
    address:"",          //地点
    downSelectionVal:0,  //当前点击
    pageListShow:true,
    hasAddAuth : true, //是否有添加课程的权限
    };
  },
  methods: {
    //获取列表数据
    async getCurriculum(query) {
      console.log("请求传入的参数",query)
      try {
        let { sendSync, get } = this.$api;
        //查询参数
        let queryData = {
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          salesId: this.$wxuserUtil.getUserId() //销售用户id
        };
        Object.assign(queryData, query || {});
        //列表数据
        let listdata = await get("api/course/list", queryData);
        if (!listdata.success) {
          console.log(listdata);
          Toast(listdata.msg);
          return;
        }
        let {
          totalRow, //	总条数
          pageNumber, // 当前页
          firstPage, //	非必须
          lastPage,
          totalPage,
          pageSize,
          list //列表数据
        } = listdata.data;
        this.totalRow = totalRow; //	总条数
        this.pageNumber = pageNumber; // 当前页
        this.firstPage = firstPage; //	非必须
        this.lastPage = lastPage; //	非必须
        this.totalPage = totalPage; //	总页数
        this.pageSize = pageSize; //	每页条数

        let newListArr = [];

        //处理列表数据
        for (const iterator of list) {
          newListArr.push({
            form: "",
            name1: "课程类型",
            name2: "课程名称",
            name3: "培训导师",
            name4: "日期",
            name5: "城市",
            name6: "学员人数",
            courseType: iterator.type,
            courseName: iterator.name,
            teacherId: iterator.teacherName,
            rangeTime: iterator.courseTime,
            city: iterator.city,
            studentCnt: iterator.sudentCnt,
            status: iterator.status, //课程状态
            courseId: iterator.courseId
          });
        }
        this.listcontent = [...this.listcontent, ...newListArr];
                // 判断是否有数据
        if( this.listcontent.length==0||this.listcontent.length>=totalRow){
          this.loading=false;
          this.finished=true;
        }
      } catch (error) {
        console.log(error);
        Toast("发生错误!" + error.message);
      }
    },
    //导航栏返回
    async onClickLeft() {
      Toast("导航栏返回");
      this.$router.back(-1);
    },
    //导航栏更多
    async onClickRight() {
      Toast("导航栏更多");
      this.$router.back(1);
    },
    //跳转详情页面
    async toDetail(item, index) {
      try {
        let { courseId,status } = item;
        this.$router.push({
          path: "/detailsCurriculum",
          query: { courseId,status, salesId: null }
        });
      } catch (error) {
        Toast("发生错误!");
      }
    },
    //选择器显示
    async pickerClick(item_index, items) {
      try {
        let { sendSync, get } = this.$api;
        let tcode;
        if (item_index == 1) {
          tcode = dictionary[`感兴趣课程&课程类型`];
        } else if (item_index == 2) {
          tcode = dictionary[`导师类型`];
        } else if (item_index == 3) {
          tcode = dictionary[`学员类型`];
        }
        //根据字典Code查询字典项
        let queryByTcode = await get(
          "api/dict/queryByTcode?tcode=" + tcode,
          {}
        );
        if (!queryByTcode.success) {
          Toast(queryByTcode.msg);
          return;
        }
        //全部日期
        if (item_index == 0) {
          queryByTcode.data = [
            "最近一周",
            "最近一月",
            "最近三个月",
            "最近半年"
          ];
        }
        console.log(item_index, items, 1111);
        this.filtrateList[item_index].show = true;
        this.filtrateList[item_index].pickerList = [{name:"全部",id:"",value:''}].concat(queryByTcode.data);

      } catch (error) {
        console.log(error.message);
        Toast("发生错误!" + error.message);
      }
    },
    //点击取消按钮时触发
    async onCancel(item_index) {
      try {
        console.log(item_index);
        this.filtrateList[item_index].show = false;
      } catch (error) {
        console.log(error.message);
        Toast("发生错误!");
      }
    },
    //点击完成按钮时触发
    async onConfirm(values, item, item_index) {
      console.log('values',values)
      console.log('item',item)
      console.log('item_index',item_index)
      return;
      try {
        let value,
          query = {}; //查询条件
        //全部日期
        if (item_index == 0) {
          value = values;
          let index_item = item.pickerList.indexOf(values);
        } else {
          value = values.name;
          this.filtrateList[item_index].value = values.value;
        }
        this.filtrateList[item_index].show = false;
        this.filtrateList[item_index].name = value;

        for (let index = 0; index < this.filtrateList.length; index++) {
          const element = this.filtrateList[index];
          if (index == 0) {
            let index_item = element.pickerList.indexOf(element.name);
            Object.assign(query, { [element.attribute]: index_item + 1 });
            continue;
          }
          Object.assign(query, { [element.attribute]: element.value });
        }
        this.listcontent = [];
        //筛选条件
        await this.getCurriculum(query);
      } catch (error) {
        console.log(error.message);
        Toast("发生错误!");
      }
    },
    //跳转日历
    async calendar() {
      this.$router.push({ path: "/calendarCurriculum", query: {} });
    },
    /**
     * @name 初始化 获取字典参数
     *
     */
    async init_dictionary() {
      try {
        let { sendSync, get } = this.$api;
        //查询全部的字典KEY
        let dictall = await get("api/dict/all", {});
        if (dictall.success) {
          for (const iterator of dictall.data) {
            Object.assign(dictionary, {
              [`${iterator.tname}`]: iterator.tcode
            });
          }
        } else {
          Toast(dictall.msg);
          return;
        }
        //查询国家
        let contuny = await get("api/common/contuny", {});
        if (!contuny.success) {
          Toast(contuny.msg);
          return;
        }
        console.log(dictionary);
        findContuny = contuny.data;
        //根据字典Code查询字典项
        //根据上级区域ID查询区域列表
      } catch (error) {
        console.log(error);
        Toast("发生错误!");
      }
    }
    /**
     *
     *   ======================================================================================
     *                                       重置
     *   =====================================================================================
     *
     *
     */
    ,
     /**
     *  高级搜索
     */
    searchFilter() {

      this.$router.push({ path: "/queryCurriculum", query: {} });
    },
    //添加页面
    addCurriculum() {
        this.$router.push({ path: "/addCurriculum", query: {title:'添加课程'} });
    },
    /**
     *
     * 字典查询
     *
     */
    getQueryByTcode() {
      for (let i = 0; i < this.codeList.length; i++) {
        this.$api.getQueryByTcode({ tcode: this.codeList[i] })
          .then(Response => {
            switch (this.codeList[i]) {
              case "CourseDateSearch"        :  this.dateTypeList = Response.data;break;
              case "Classes"                 :  this.courseTypeList = Response.data;break;
              case "teacherType"             :  this.teacherTypeList = Response.data;break;
              case "StudentType"             :  this.studentTypeList = Response.data;break;
            }
          });
      }
    },
   onCancelCode(){
     this.showDownSelection=false;
   },
   onConfirmCode(val){
    console.log("弹框确认按钮",val)
    let $list=[];
        $list=this.filtrateList;
        $list[this.downSelectionVal]['name']=val.name;
        this.filtrateList=$list;
    switch(this.downSelectionVal){
       case 0   :   this.dateType=val.value;break
       case 1   :   this.courseType=val.value;break
       case 2   :   this.teacherType=val.value;break
       case 3   :   this.studentType=val.value;break
    }
    this.list=[]
    this.pageNumber=1;
    this.loading = false;
    this.finished = false;
    this.getDataList(1,1)
    this.showDownSelection=false;
   },


   onLoad() {
        setTimeout(()=>{
                  // 异步更新数据
        if(this.pageListShow==true){
        this.loading = false;
        this.finished = false;
        this.pageNumber =  parseInt(this.pageNumber+ 1);
        this.getDataList(2,this.pageNumber);
        }
        },500)
    },

   /**
    *
    *   查询列表数据
    *
    */
   getDataList(ID,Page){
              let data={};
              data['salesId']=this.$wxuserUtil.getUserId();
              data['pageNumber']=Page;
              data['pageSize']=this.pageSize;
              data['likeName']=this.likeName;   //模糊查询
              data['dateType']=this.dateType;   //日期类型1、最近一周 2、最近一月 3、最近三个月 4、最近半年
              data['courseType']=this.courseType; //课程类型
              data['teacherType']=this.teacherType; //导师类型
              data['studentType']=this.studentType; //学员类型
              data['courseName']=this.courseName;   //课程名称
              data['teacherName']=this.teacherId;     //培训导师
              data['startDate']=this.startDate;     //课程开始日期
              data['endDate']=this.endDate;         //课程结果日期
              data['city']=this.city;               //城市
              data['startStudentCnt']=this.startStudentCnt;     //学员开始人数
              data['endStudentCnt']=this.endStudentCnt;         //学员结束人数
              data['currency']=this.currency;                   //课程费用币种
              data['startPrice']=this.startPrice;               //单人费用开始费用
              data['endPrice']=this.endPrice;                   //单人费用结束费用
              data['startAmount']=this.startAmount;             //费用合计开始
              data['endAmount']=this.endAmount;                 //费用合计结束
              data['neededShow']=this.neededShow;               //是否需要提交作品
              data['address']=this.address;                     //详细地址
              data['country']=this.country;                     //国家
              this.pageListShow=false;
              var Response  =this.$api.getCourseList(data);
                   if(Response.success){
                     if(ID==1){
                             this.list=Response.data.list;
                             if(Response.data.list.length==0||!Response.data.list){
                              this.finished = true;
                             }else{
                               this.finished=false;
                             }
                             this.totalRow=Response.data.totalRow;
                             this.pageListShow=true;
                     }else{
                             this.list=this.list.concat(Response.data.list||[])
                             if(Response.data.list.length==0||this.list.length>=Response.data.totalRow){
                              this.finished = true;
                             }else{
                              this.finished=false;
                             }
                             this.pageListShow=true;
                     }
                   }else{
                      this.$title("请求异常")
                   }

   },

   /**
    *
    *  点击下拉列表 获取当前索引
    *
    */
   downSelectionL(index){
       console.log("当前索引",index)
       this.downSelectionVal=index;
       switch(index){
          case 0    :  this.downSelection=this.setCodeAlls(this.dateTypeList);break
          case 1    :  this.downSelection=this.setCodeAlls(this.courseTypeList);break
          case 2    :  this.downSelection=this.setCodeAlls(this.teacherTypeList);break
          case 3    :  this.downSelection=this.setCodeAlls(this.studentTypeList);break
       }
       this.showDownSelection=true;
   },
   /**
    *
    *   添加全部
    *
    */
   setCodeAlls(data){
      if(Array.isArray(data)){
        return  [{name:"全部",value:""}].concat(data);
      }else{
        return  [].concat(data);
      }
   },
      //搜索按钮
   search() {
        this.likeName=this.search_input;
        if(this.search_input==""||this.search_input==null){
          this.toEmpty();
        }
         this.list=[]
         this.pageNumber=1;
        this.loading = false;
        this.finished = false;
        this.getDataList(1,1)

    },
  //清空全部
  toEmpty(){
    this.likeName=""       //模糊查询
    this.dateType=""       //日期类型1、最近一周 2、最近一月 3、最近三个月 4、最近半年
    this.courseType=""     //课程类型
    this.teacherType=""   //导师类型
    this.studentType=""        //学员类型
    this.courseName=""         //课程名称
    this.teacherId=""          //培训导师
    this.startDate=""          //课程开始日期
    this.endDate=""           //课程结果日期
    this.country=""            //国家
    this.city=""               //城市
    this.startStudentCnt=""    //学员开始人数
    this.endStudentCnt=""      //学员结束人数
    this.currency=""           //课程费用币种
    this.startPrice=""         //单人费用开始费用
    this.endPrice=""         //单人费用结束费用
    this.startAmount=""        //费用合计开始
    this.endAmount=""        //费用合计结束
    this.neededShow=""       //是否需要提交作品
    this.address=""          //地点

    this.getDataList(1,1)
  },
   home(){ this.$router.push({ path: "/"});  },







  },
  mounted() {
    this.hasAddAuth = this.$wxuserUtil.hasFunAuthByRoute(this.$route.path,this.$wxuserUtil.funcKey.Created);
    this.getQueryByTcode();
    let $obj   =  this.$route.params;
    for (let val in $obj){
        switch(val){
          case   'address'        :    this.address=$obj[val]||'';break        //详情地址
          case   'courseName'     :    this.courseName=$obj[val]||'';break     //课程名称
          case   'city'           :    this.city=$obj[val]||'';break           //城市
          case   'teacherId'      :    this.teacherType=$obj[val]||'';break    //导师类型
          case   'amounts'        :    this.endAmount=$obj[val]||'';break      //合计费用结束
          case   'amount'         :    this.startAmount=$obj[val]||'';break    //合计费用开始
          case   'neededShow'     :    this.neededShow=$obj[val]||'';break     //提交作品
          case   'price'          :    this.startPrice=$obj[val]||'';break     //单人费用开始费用
          case   'prices'         :    this.endPrice=$obj[val]||'';break       //单人费用结束费用
          case   'currency'       :    this.currency=$obj[val]||'';break       //课程费用币种
          case   'studentCnt'     :    this.startStudentCnt=$obj[val]||'';break     //学员开始人数
          case   'studentCnts'    :    this.endStudentCnt=$obj[val]||'';break       //学员结束人数
          case   'startDate'      :    this.startDate=$obj[val]||'';break           //课程开始日期
          case   'endDate'        :    this.endDate=$obj[val]||'';break             //课程结果日期
          case   'tutorial'       :    this.teacherId=$obj[val]||'';break           //培训导师
          case   'courseType'     :    this.studentType=$obj[val]||'';break         //学员类型
          case   'courseTypes'    :    this.courseType=$obj[val]||'';break          //客户类型
          case   'country'        :    this.country=$obj[val]||'';break             //国家
        }
    }
         this.list=[]
         this.pageNumber=1;
         this.finished=false;
     this.getDataList(1,1);
      document.getElementById('app').scrollTop =  0;

  },
  created() {
  },
  watch: {},
  components: {}
};
</script>

<style lang="less"   scoped>
// @import url("../../style/pageStyle/pageView-client.less");

 // 定位
  .orientation-bottom {
    position: fixed;
    bottom: 1.5rem;
    right: 0.3rem;
    z-index: 10;
    width: 1rem;
    height: 2.5rem;
    border: 1px solid transparent;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: #000000;
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
    border-bottom-left-radius: 1rem;
    border-bottom-right-radius: 1rem;
    .homePageImg,
    .addImg {
      width: 0.5rem;
      height: 0.5rem;
    }
    .homePage,
    .add {
      height: 1.25rem;
      line-height: 1.25rem;
      width: 100%;
      align-items: center;
      text-align: center;
    }
    .homePage {
      border-bottom: 1px solid #5e5e5e;
    }
  }

  .orientation-bottom-1 {
    position: fixed;
    bottom: 1.5rem;
    right: 0.3rem;
    z-index: 10;
    width: 1rem;
    height: 1rem;
    border: 1px solid transparent;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: #000000;
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
    border-bottom-left-radius: 1rem;
    border-bottom-right-radius: 1rem;
    .homePageImg,
    .addImg {
      width: 0.5rem;
      height: 0.5rem;
    }
    .homePage,
    .add {
      height: 1.25rem;
      line-height: 1.25rem;
      width: 100%;
      align-items: center;
      text-align: center;
    }
  }

.filtratelist {
  position: fixed;
  width: 100%;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  font-size: 12px;
  background: #fff;
}
.span_text {
  position: relative;
  padding-left: .2rem;
  font-size:.35rem;
  width:1.5rem;
  height: 1rem;
  text-align: center;
   line-height: .5rem;
  display: flex;
    text-align: left;
   white-space: pre-wrap;

  .span_text_flex{

  }
    .uparrow {
    width: 0.3rem;
    height: 0.3rem;
    margin-top: -0.15rem;
    position: absolute;
    top: .3rem;
    // top:50%;
    right: -.3rem;
    margin-left: .1rem;
  }

}
.filtrate {
  width: 1rem;
  height: 1rem;
}
.filtrate > img {
  width: 100%;
  height: 100%;
  background: white;
}
.header-titile-all {
  background: #f4f4f4;
  overflow: hidden;
  // height: 5rem;
  // position: fixed;
  // left: 0rem;
  // top: 0rem;
  width: 100%;
  z-index: 1000;
  .searchTitle-top-header,.searchTitle-top,.input-search-flex,.search_input{
    background: #f4f4f4;
  }
}
.searchTitle-top-header {
  margin: 0.3rem;
  height: 1rem;
  .searchTitle-top {
    // background: #fff;
    display: flex;
    flex-direction: row;
    // justify-content: space-between;
    height: 1rem;
    align-items: center;
    flex: 1;

    .input-search-flex {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 100%;
    }

    .search_input {
      border: none;
      outline: none;
      padding-left: 0.18rem;
      width: 85%;
    }
    .picker-alls {
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 100%;
      padding: 0 0.3rem;
      border-right: 1px solid #f0f0f0;
    }
    .search-img {
      width: 0.5rem;
      height: 0.5rem;
      margin-right: .3rem;
    }
  }
  .filtrate-img {
    width: 0.5rem;
    height: 0.5rem;
  }

  .filtrate-list {
    width: 1.5rem;
    text-align: center;
    align-items: center;
    height: 1rem;
    line-height: 1rem;
    overflow: hidden;
    padding-left: 0.18rem;
    background: #fff;
  }
}
.v2_pl2gj1 {
  display: block;
  margin: 0 auto;
  width: 0.5rem;
  height: 0.5rem;
  padding-top: 0.0rem;
}
.listcontent {
  height:auto;
  width: 100%;
  margin-bottom: 2.5rem;
  // border-top: 1px solid rgb(187, 187, 187);
  margin-top: 3rem;
}
.information-list {
  margin: 0.2rem;
  left: 7px;
  top: 170px;
  // width: 100%;
  min-height: 116px;
  line-height: 20px;
  // border-radius: 20px;
  background-color: rgba(255, 255, 255, 1);
  color: rgba(16, 16, 16, 1);
  font-size: 14px;
  // text-align: center;
  font-family: Arial;
  // border: 1px solid rgba(167, 167, 167, 1);
  padding: .3rem .5rem;
  // position: relative;
}
.add2-bottom {
  width: 1rem;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  -ms-flex-item-align: center;
  align-items: center;
  position: fixed;
  bottom: 2rem;
  right: 1rem;
  z-index: 1000;
  border-radius: .5rem;
}
.loaded {
  position: fixed;
  bottom: 0rem;
  height: 0.8rem;
  line-height: 0.8rem;
  text-align: center;
  background: rgba(000, 000, 000, 0.35);
  color: #fff;
  width: 100%;
}
.list-van-row {
  padding-top: 0.1rem;
}
.header_top {
  position: fixed;
  width: 100%;
  background: #ffffff;
  z-index: 1000;
}

// 修改部分样式

.list-row{
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  .list-row-item{
    width:3rem;
    color: #7e7e7e;
    font-size: 0.35rem;
  }
  .list-row-items{
    width:5.2rem;
    font-size: 0.35rem;
    color: #4d4d4d;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap
  }
    .list-row-item-active{
      color:red!important;
    }
    .top-flex{
      position: relative;
    .concal-flex{
    position: absolute;
    right: 0rem;
    top: 0rem;

  }
    }
}


</style>




// WEBPACK FOOTER //
// src/components/lkcollege/listCurriculum.vue